import React from 'react';
import {
    NavLink as RouterLink,

  } from 'react-router-dom';
import {
  Box,
  Button,
  Card,
  CardHeader,
  Divider,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,

} from '@mui/material';
import { ApiUrl } from 'features/api_url';
import axios from 'axios';
import { ArrowRightAlt } from '@mui/icons-material';
import currencyFraction from 'utils/currencyFraction';
import ExpensesDatesFilter from './ExpensesDatesFilter';

const ExpensesBySupplier = (props) => {

    const [fromDate, setFromDate] = React.useState(props.fromDate);
    const [toDate, setToDate] = React.useState(props.toDate);

    const [totalAmount, setTotalAmount] = React.useState(0);
    const [totalVat, setTotalVat] = React.useState(0);

    const [suppliersData, setSuppliersData] = React.useState(null);

    const abortCtrl = new AbortController();

    const onFilter =(dates) => {

        setFromDate(dates.fromDate);
        setToDate(dates.toDate);
    }

    React.useEffect(() => {
  
      const getData = async () => {
        await axios.post(ApiUrl + 'stats/getExpensesSupplierData',{ from: fromDate, to: toDate},{ signal: abortCtrl.signal})
          .then(response => {
  
            if(response.data) setSuppliersData(response.data);
  
          })
          .catch((err) => console.log('ABORTING: ', err));
        
      }
  
      getData();
  
      return () => {
        console.log("UNMOUNTING supplier data:");
        abortCtrl.abort();
      }
  
    },[fromDate, toDate]);

    React.useEffect(() => {

        if(suppliersData){

            let ta = suppliersData.reduce((prev,next) => parseFloat(prev) + parseFloat(next.total),0);
            let tv = suppliersData.reduce((prev,next) => parseFloat(prev) + parseFloat(next.vat),0);

            setTotalAmount(ta);
            setTotalVat(tv);
        }
    },[suppliersData]);

    return (
        <Card>
            <CardHeader
                title="Expenses by supplier"
            />
            <Divider />
            <ExpensesDatesFilter onSubmit={onFilter} fromDate={fromDate} toDate={toDate} />
            <Box sx={{p:2}} >
                Total amount: <strong>{ currencyFraction.format(totalAmount) }</strong>
                {' '}
                Total VAT: <strong>{ currencyFraction.format(totalVat) }</strong> 
            </Box>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>
                            Supplier
                        </TableCell>
                        <TableCell>
                            Amount
                        </TableCell>
                        <TableCell>
                            Vat
                        </TableCell>
                        <TableCell>
                            Orders
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    { suppliersData && suppliersData.map(supplier =>
                    <TableRow key={supplier.supplier}>
                        <TableCell>{supplier.supplier}</TableCell>
                        <TableCell>{currencyFraction.format(supplier.total)}</TableCell>
                        <TableCell>{currencyFraction.format(supplier.vat)}</TableCell>
                        <TableCell>{supplier.nooforders}</TableCell>
                    </TableRow>
                    )}
                    { !suppliersData &&
                        <TableRow>
                            <TableCell colSpan={4}>No data to show</TableCell>
                        </TableRow>
                    }
                </TableBody>
            </Table>
            <Divider />
            <Box
            sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                p: 2
            }}
            >


            </Box>
        </Card>
    );
};

export default ExpensesBySupplier;
